<div ngbDropdown #languageDropdown="ngbDropdown">
  <button
    type="button"
    [id]="uniqueId"
    ngbDropdownToggle
    class="tw-flex-shrink-0 tw-z-10 tw-inline-flex tw-items-center tw-py-2.5 tw-px-4 tw-text-sm tw-font-medium tw-text-center tw-text-gray-500 tw-bg-transparent tw-rounded-lg hover:tw-bg-gray-100 focus:tw-outline-none"
  >
    <div
      class="tw-inline-flex tw-justify-center tw-items-center tw-gap-2 tw-mx-2"
    >
      <cohrex-svg [name]="selectedLanguage.flag" />
      @if (showLanguageLabel) {
        <span>{{ selectedLanguage.name }}</span>
      }
    </div>
  </button>
  <div ngbDropdownMenu [attr.aria-labelledby]="uniqueId">
    <ul
      class="tw-py-2 tw-text-sm tw-text-gray-700"
      [attr.aria-labelledby]="uniqueId"
    >
      @for (lang of languages; track lang.code) {
        <li (click)="selectLanguage(lang.code)">
          <button
            type="button"
            class="tw-inline-flex tw-w-full tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100"
          >
            <div class="tw-inline-flex tw-gap-3 tw-items-center">
              <cohrex-svg [name]="lang.flag" />
              {{ lang.name }}
            </div>
          </button>
        </li>
      }
    </ul>
  </div>
</div>
